// Fields that can be shown on a job-board card.
//
// All of these already exist on Project — this is about which ones surface on the
// card, not about defining new data. `render` takes the project and returns a
// string (or null to omit the row entirely, so a card never shows an empty label).
//
// `kind` drives layout: 'meta' items sit inline on the bottom row with the cost and
// day count; 'text' items get their own line and are clamped to a couple of lines
// so one long repair description can't turn a card into a wall.
const money = (n) => (typeof n === 'number' ? `$${n.toLocaleString()}` : null);
const date = (d) => (d ? new Date(d).toLocaleDateString() : null);
const text = (s) => {
  const trimmed = (s ?? '').trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const BOARD_CARD_FIELDS = [
  { key: 'customer',          label: 'Customer',            kind: 'text',
    render: (p) => text(p.customer ? `${p.customer.firstName || ''} ${p.customer.lastName || ''}`.trim() || p.customer.companyName : '') },
  { key: 'address',           label: 'Property Address',    kind: 'text',
    render: (p) => text(p.customer?.propertyStreet) },
  { key: 'poNumber',          label: 'PO Number',           kind: 'meta',
    render: (p) => text(p.poNumber) },
  { key: 'estimatedCost',     label: 'Estimated Cost',      kind: 'meta',
    render: (p) => money(p.estimatedCost) },
  { key: 'finalCost',         label: 'Final Cost',          kind: 'meta',
    render: (p) => money(p.finalCost) },
  { key: 'daysInStatus',      label: 'Days in Stage',       kind: 'meta', special: 'days' },
  { key: 'scheduledStartDate',label: 'Scheduled Start',     kind: 'meta',
    render: (p) => date(p.scheduledStartDate) },
  { key: 'workOrderStartDate',label: 'Work Order Start',    kind: 'meta',
    render: (p) => date(p.workOrderStartDate) },
  { key: 'description',       label: 'Description',         kind: 'text',
    render: (p) => text(p.description) },
  { key: 'repairDescription', label: 'Repair Description',  kind: 'text',
    render: (p) => text(p.repairDescription) },
  { key: 'workOrderText',     label: 'Work Order / Instructions', kind: 'text',
    render: (p) => text(p.workOrderText) },
  { key: 'notes',             label: 'Notes',               kind: 'text',
    render: (p) => text(p.notes) },
  { key: 'repairLabor',       label: 'Repair Labor',        kind: 'meta',
    render: (p) => money(p.repairLabor) },
  { key: 'repairPrice',       label: 'Repair Price',        kind: 'meta',
    render: (p) => money(p.repairPrice) },
  { key: 'claimNumber',       label: 'Claim Number',        kind: 'meta',
    render: (p) => text(p.claimNumber) },
  { key: 'insuranceCarrier',  label: 'Insurance Carrier',   kind: 'meta',
    render: (p) => text(p.insuranceCarrier) },
  { key: 'shingle',           label: 'Shingle',             kind: 'meta',
    render: (p) => text([p.shingleBrand, p.shingleLine, p.shingleColor].filter(Boolean).join(' · ')) },
];

// What a card shows before anyone customises it — the previous hardcoded layout,
// so an existing user's board doesn't change under them.
export const DEFAULT_CARD_FIELDS = ['customer', 'estimatedCost', 'daysInStatus'];

export const boardCardField = (key) => BOARD_CARD_FIELDS.find(f => f.key === key);
